<!-- Navigation links start here -->
<div class="shop-wrapper text-center" *ngIf="fanInlibleStatus || loginErrorMessage!=null">
  <!-- <div class="shop-wrapper text-center" *ngIf="loginErrorMessage!=null"> -->
  <!-- Code for Login Error Banner -->
  <div class="container-box">
    <div class="alert valign-children-middle mar-top-20">
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div style="text-align: left;">
        <h2>{{fanInlibleStatus ? "Access Denied" : errorHeader}}</h2>
        <p *ngIf="stubIdErrorMsg">{{loginErrorMessage}} Please contact our <a href='/businessconsole/contact'>support</a> team for assistance.</p>
        <p *ngIf="!stubIdErrorMsg && !fanInlibleStatus">{{loginErrorMessage}}</p>
        <p *ngIf="!stubIdErrorMsg && fanInlibleStatus">{{fansInEligibleErrorMsg1}}<br/>{{fansInEligibleErrorMsg2}}<br/>{{fansInEligibleErrorMsg3}}</p>
      </div>
    </div>
  </div>
</div>
<!-- Navigation links end here -->
<!-- slider start here -->
<div style="background-color: aliceblue;">
  <app-page-slider (mouseenter)="showArrows='visible'" (mouseleave)="showArrows='hidden'" [data]="homePage.sliderNew"
    [(page)]="pageNumber" [transitionDuration]="transitionDuration" [transitionInterval]="transitionInterval">
    <div *carouselPages="let page of homePage.sliderNew" class="page" [style.background]="page.color">
      <img class="hide-small underImg" src="{{page.image}}" alt="{{page.title}}" style="width: 100%;" />
      <img class="hide-small overImg" src="{{homePage?.colorImage}}" alt="{{homePage?.colorImage}}"
        style="width: 100%;  height: auto;" />
      <img class="show-small" style="width: 100%;height: 415px;" src="{{page.smallImage}}" alt="{{page.title}}" />
      <img class="show-small overImg" src="{{homePage?.colorImage}}" alt="{{homePage?.colorImage}}"
        style="width: 100%;height: 415px;" />
      <div class="caption-text">
        <div class="container-box inner-wrap container-inner">
          <div class="row" [ngClass]="{'caption-white':(page.captionWhite== true)}">
            <div class="col-sm-12 col-md-6 banner-desc" [ngClass]="{'caption-background':(page.captionBg== true)}">
              <div class="eyebrow-text" *ngIf="page.eyeBrowText!==''">{{page.eyeBrowText}}</div>
              <h1 class="slider-heading slider-title" [innerHTML]="page.title"></h1>
              <p class="hide-small"
                style="color: #FFFFFF; font-size: 25px; font-family: 'Omnes-ATT-W02'; margin-top: -7px">
                {{homePage?.slider[0]?.shortDescription1}}</p>
              <p class="hide-small slider-heading slider-short-description" style="font-size: 15px; width: 42%;">
                {{homePage?.slider[0]?.shortDescription2}}</p>
              <p class="show-small slider-heading slider-short-description" style="width: 81%;">
                {{homePage?.slider[0]?.shortDescription2}}</p>
              <a href="javascript:void(0)" *ngIf="homePage?.slider[0]?.buttonFlag"
                (click)="checkSlider(homePage?.slider[0]?.buttonLink, homePage?.slider[0]?.title)"
                [attr.aria-label]="homePage?.slider[0]?.buttonAccessibilityText ? homePage?.slider[0]?.buttonAccessibilityText : null"
                class="btn btn-secondary learn-more-button" style="color: #3A6EB2; width: 180px; height: 40px;">
                {{homePage?.slider[0]?.actionLabelNew}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-page-slider>
  <!-- slider end here -->

  <!-- navigation links start here -->
  <!-- <div *ngIf = "show5gTile" class="shop-wrapper text-center article-list article-info">
    <a (click)="checkSlider(homePage?.slider[1]?.buttonLink, homePage?.slider[1]?.title)" style="cursor: pointer;">
      <article>
        <div class="article-info tilesForDesktop">
          <span class="heading-4">{{homePage?.slider[1]?.title}}</span>
          <p class="align">{{homePage?.slider[1]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[1]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[1]?.buttonLink, homePage?.slider[1]?.title)"
            [attr.aria-label]="homePage?.slider[1]?.buttonAccessibilityText ? homePage?.slider[1]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </a> -->
    <!--------------------- mobile view code ----------------------------->
    <!-- <div class="tilesForMobile">
      <article>
        <div class="article-info">
          <span class="hideArrow">
            <img [style.display]="openTiles1 ? '' : 'none'" id='show' class="dropdownMenu"
              src="assets/img/expandTiles.png" alt="image icon for expandTiles"
              (click)="expandCollapseTiles1('show');" />
            <img [style.display]="closeTiles1 ? '' : 'none'" id='hide' class="dropdownMenuUp"
              src="assets/img/collapseTiles.png" alt="image icon for collapseTiles"
              (click)="expandCollapseTiles1('hide');" />
          </span>
          <span [style.display]="openTiles1 ? '' : 'none'" id='show' (click)="expandCollapseTiles1('show')">
            <span class="heading-4">{{homePage?.slider[1]?.title}}</span>
          </span>
          <span [style.display]="closeTiles1 ? '' : 'none'" id='hide' (click)="expandCollapseTiles1('hide')">
            <span class="heading-4">{{homePage?.slider[1]?.title}}</span>
          </span> -->

          <!--------------------- mobile view code ----------------------------->

          <!-- <p class="align" [class.shortDesc]="hideShortDesc1">{{homePage?.slider[1]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[1]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[1]?.buttonLink, homePage?.slider[1]?.title)"
            [attr.aria-label]="homePage?.slider[1]?.buttonAccessibilityText ? homePage?.slider[1]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn" [class.hideLearnMore]="hideLearnMore1">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </div> -->

    <!-- <a (click)="checkSlider(homePage?.slider[2]?.buttonLink, homePage?.slider[2]?.title)" style="cursor: pointer;">
      <article>
        <div class="article-info tilesForDesktop">
          <span class="heading-4">{{homePage?.slider[2]?.title}}</span>
          <p class="align" style="padding-bottom: 15px;">{{homePage?.slider[2]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[2]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[2]?.buttonLink, homePage?.slider[2]?.title)"
            [attr.aria-label]="homePage?.slider[2]?.buttonAccessibilityText ? homePage?.slider[2]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </a> -->
    <!--------------------- mobile view code ----------------------------->
    <!-- <div class="tilesForMobile">
      <article>
        <div class="article-info">
          <span class="hideArrow">
            <img [style.display]="openTiles2 ? '' : 'none'" id='show' class="dropdownMenu"
              src="assets/img/expandTiles.png" alt="image icon for openTiles2"
              (click)="expandCollapseTiles2('show');" />
            <img [style.display]="closeTiles2 ? '' : 'none'" id='hide' class="dropdownMenuUp"
              src="assets/img/collapseTiles.png" alt="image icon for closeTiles2"
              (click)="expandCollapseTiles2('hide');" />
          </span>
          <span [style.display]="openTiles2 ? '' : 'none'" id='show' (click)="expandCollapseTiles2('show')">
            <span style="line-height: 25px;" class="heading-4">{{homePage?.slider[2]?.title}}</span>
          </span>
          <span [style.display]="closeTiles2 ? '' : 'none'" id='hide' (click)="expandCollapseTiles2('hide')">
            <span style="line-height: 25px;" class="heading-4">{{homePage?.slider[2]?.title}}</span>
          </span> -->
          <!--------------------- mobile view code ----------------------------->
          <!-- <p class="align" [class.shortDesc]="hideShortDesc2">{{homePage?.slider[2]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[2]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[2]?.buttonLink, homePage?.slider[2]?.title)"
            [attr.aria-label]="homePage?.slider[2]?.buttonAccessibilityText ? homePage?.slider[2]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn" [class.hideLearnMore]="hideLearnMore2">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </div> -->

    <!-- <a (click)="checkSlider(homePage?.slider[3]?.buttonLink, homePage?.slider[3]?.title)" style="cursor: pointer;">
      <article>
        <div class="article-info tilesForDesktop">
          <span class="heading-4" style="padding-bottom: 0px;">{{homePage?.slider[3]?.title}}</span>
          <p class="align" style="padding-bottom: 25px;">
            {{homePage?.slider[3]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[3]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[3]?.buttonLink, homePage?.slider[3]?.title)"
            [attr.aria-label]="homePage?.slider[3]?.buttonAccessibilityText ? homePage?.slider[3]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </a>
    <div class="tilesForMobile"> -->
      <!--------------------- mobile view code ----------------------------->
      <!-- <article>
        <div class="article-info">
          <span class="hideArrow">
            <img [style.display]="openTiles3 ? '' : 'none'" id='show' class="dropdownMenu"
              src="assets/img/expandTiles.png" alt="image icon for openTiles3"
              (click)="expandCollapseTiles3('show');" />
            <img [style.display]="closeTiles3 ? '' : 'none'" id='hide' class="dropdownMenuUp"
              src="assets/img/collapseTiles.png" alt="image icon for closeTiles3"
              (click)="expandCollapseTiles3('hide');" />
          </span>
          <span [style.display]="openTiles3 ? '' : 'none'" id='show' (click)="expandCollapseTiles3('show')">
            <span class="heading-4">{{homePage?.slider[3]?.title}}</span>
          </span>
          <span [style.display]="closeTiles3 ? '' : 'none'" id='hide' (click)="expandCollapseTiles3('hide')">
            <span class="heading-4">{{homePage?.slider[3]?.title}}</span>
          </span> -->
          <!--------------------- mobile view code ----------------------------->
          <!-- <p class="align" [class.shortDesc]="hideShortDesc3">{{homePage?.slider[3]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[3]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[3]?.buttonLink, homePage?.slider[3]?.title)"
            [attr.aria-label]="homePage?.slider[3]?.buttonAccessibilityText ? homePage?.slider[3]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn" [class.hideLearnMore]="hideLearnMore3">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </div> -->

    <!-- <a (click)="checkSlider(homePage?.slider[4]?.buttonLink, homePage?.slider[4]?.title)" style="cursor: pointer;">
      <article>
        <div class="article-info tilesForDesktop">
          <span class="heading-4" style="padding-bottom: 0px;">{{homePage?.slider[4]?.title}}</span>
          <p class="align" style="margin-bottom: 8px;">
            {{homePage?.slider[4]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[4]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[4]?.buttonLink, homePage?.slider[4]?.title)"
            [attr.aria-label]="homePage?.slider[4]?.buttonAccessibilityText ? homePage?.slider[4]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </a>

    <div class="tilesForMobile"> -->
      <!--------------------- mobile view code ----------------------------->
      <!-- <article>
        <div class="article-info">
          <span class="hideArrow">
            <img [style.display]="openTiles4 ? '' : 'none'" id='show' class="dropdownMenu"
              src="assets/img/expandTiles.png" alt="image icon for openTiles4"
              (click)="expandCollapseTiles4('show');" />
            <img [style.display]="closeTiles4 ? '' : 'none'" id='hide' class="dropdownMenuUp"
              src="assets/img/collapseTiles.png" alt="image icon for closeTiles3"
              (click)="expandCollapseTiles4('hide');" />
          </span>
          <span [style.display]="openTiles4 ? '' : 'none'" id='show' (click)="expandCollapseTiles4('show')">
            <span class="heading-4">{{homePage?.slider[4]?.title}}</span>
          </span>
          <span [style.display]="closeTiles4 ? '' : 'none'" id='hide' (click)="expandCollapseTiles4('hide')">
            <span class="heading-4">{{homePage?.slider[4]?.title}}</span>
          </span> -->
          <!--------------------- mobile view code ----------------------------->
          <!-- <p class="align" [class.shortDesc]="hideShortDesc4">{{homePage?.slider[4]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[4]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[4]?.buttonLink, homePage?.slider[4]?.title)"
            [attr.aria-label]="homePage?.slider[4]?.buttonAccessibilityText ? homePage?.slider[4]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn" [class.hideLearnMore]="hideLearnMore4">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </div>

  </div> -->

  <!-- TILES FOR FIRSTNET AND MYATT -->

  <div class="shop-wrapper text-center article-list article-info">
    <!-- <a (click)="checkSlider(homePage?.slider[1]?.buttonLink, homePage?.slider[1]?.title)" style="cursor: pointer;"> -->
      <article class="non5gTiles">
        <div class="article-info tilesForDesktop">
          <span class="heading-4">{{homePage?.slider[1]?.title}}</span>
          <p class="align">{{homePage?.slider[1]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[1]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[1]?.buttonLink, homePage?.slider[1]?.title)"
            [attr.aria-label]="homePage?.slider[1]?.buttonAccessibilityText ? homePage?.slider[1]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    <!-- </a> -->
    <!--------------------- mobile view code ----------------------------->
    <div class="tilesForMobile">
      <article>
        <div class="article-info">
          <span class="hideArrow">
            <img [style.display]="openTiles1 ? '' : 'none'" id='show' class="dropdownMenu"
              src="assets/img/expandTiles.png" alt="image icon for expandTiles"
              (click)="expandCollapseTiles1('show');" />
            <img [style.display]="closeTiles1 ? '' : 'none'" id='hide' class="dropdownMenuUp"
              src="assets/img/collapseTiles.png" alt="image icon for collapseTiles"
              (click)="expandCollapseTiles1('hide');" />
          </span>
          <span [style.display]="openTiles1 ? '' : 'none'" id='show' (click)="expandCollapseTiles1('show')">
            <span class="heading-4">{{homePage?.slider[1]?.title}}</span>
          </span>
          <span [style.display]="closeTiles1 ? '' : 'none'" id='hide' (click)="expandCollapseTiles1('hide')">
            <span class="heading-4">{{homePage?.slider[1]?.title}}</span>
          </span>

          <!--------------------- mobile view code ----------------------------->

          <p class="align" [class.shortDesc]="hideShortDesc1">{{homePage?.slider[1]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[1]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[1]?.buttonLink, homePage?.slider[1]?.title)"
            [attr.aria-label]="homePage?.slider[1]?.buttonAccessibilityText ? homePage?.slider[1]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn" [class.hideLearnMore]="hideLearnMore1">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </div>

    <!-- <a (click)="checkSlider(homePage?.slider[2]?.buttonLink, homePage?.slider[2]?.title)" style="cursor: pointer;"> -->
      <article class="non5gTiles">
        <div class="article-info tilesForDesktop">
          <span class="heading-4">{{homePage?.slider[2]?.title}}</span>
          <p class="align" style="padding-bottom: 15px;">{{homePage?.slider[2]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[2]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[2]?.buttonLink, homePage?.slider[2]?.title)"
            [attr.aria-label]="homePage?.slider[2]?.buttonAccessibilityText ? homePage?.slider[2]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    <!-- </a> -->
    <!--------------------- mobile view code ----------------------------->
    <div class="tilesForMobile">
      <article>
        <div class="article-info">
          <span class="hideArrow">
            <img [style.display]="openTiles2 ? '' : 'none'" id='show' class="dropdownMenu"
              src="assets/img/expandTiles.png" alt="image icon for openTiles2"
              (click)="expandCollapseTiles2('show');" />
            <img [style.display]="closeTiles2 ? '' : 'none'" id='hide' class="dropdownMenuUp"
              src="assets/img/collapseTiles.png" alt="image icon for closeTiles2"
              (click)="expandCollapseTiles2('hide');" />
          </span>
          <span [style.display]="openTiles2 ? '' : 'none'" id='show' (click)="expandCollapseTiles2('show')">
            <span style="line-height: 25px;" class="heading-4">{{homePage?.slider[2]?.title}}</span>
          </span>
          <span [style.display]="closeTiles2 ? '' : 'none'" id='hide' (click)="expandCollapseTiles2('hide')">
            <span style="line-height: 25px;" class="heading-4">{{homePage?.slider[2]?.title}}</span>
          </span>
          <!--------------------- mobile view code ----------------------------->
          <p class="align" [class.shortDesc]="hideShortDesc2">{{homePage?.slider[2]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[2]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[2]?.buttonLink, homePage?.slider[2]?.title)"
            [attr.aria-label]="homePage?.slider[2]?.buttonAccessibilityText ? homePage?.slider[2]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn" [class.hideLearnMore]="hideLearnMore2">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </div>

    <!-- <a (click)="checkSlider(homePage?.slider[3]?.buttonLink, homePage?.slider[3]?.title)" style="cursor: pointer;"> -->
      <article class="non5gTiles">
        <div class="article-info tilesForDesktop">
          <span class="heading-4" style="padding-bottom: 0px;">{{homePage?.slider[3]?.title}}</span>
          <p class="align" style="padding-bottom: 25px;">
            {{homePage?.slider[3]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[3]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[3]?.buttonLink, homePage?.slider[3]?.title)"
            [attr.aria-label]="homePage?.slider[3]?.buttonAccessibilityText ? homePage?.slider[3]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    <!-- </a> -->
    <div class="tilesForMobile">
      <!--------------------- mobile view code ----------------------------->
      <article>
        <div class="article-info">
          <span class="hideArrow">
            <img [style.display]="openTiles3 ? '' : 'none'" id='show' class="dropdownMenu"
              src="assets/img/expandTiles.png" alt="image icon for openTiles3"
              (click)="expandCollapseTiles3('show');" />
            <img [style.display]="closeTiles3 ? '' : 'none'" id='hide' class="dropdownMenuUp"
              src="assets/img/collapseTiles.png" alt="image icon for closeTiles3"
              (click)="expandCollapseTiles3('hide');" />
          </span>
          <span [style.display]="openTiles3 ? '' : 'none'" id='show' (click)="expandCollapseTiles3('show')">
            <span class="heading-4">{{homePage?.slider[3]?.title}}</span>
          </span>
          <span [style.display]="closeTiles3 ? '' : 'none'" id='hide' (click)="expandCollapseTiles3('hide')">
            <span class="heading-4">{{homePage?.slider[3]?.title}}</span>
          </span>
          <!--------------------- mobile view code ----------------------------->
          <p class="align" [class.shortDesc]="hideShortDesc3">{{homePage?.slider[3]?.shortDescription}}</p>
          <a href="javascript:void(0)" *ngIf="homePage?.slider[3]?.buttonFlag"
            (click)="checkSlider(homePage?.slider[3]?.buttonLink, homePage?.slider[3]?.title)"
            [attr.aria-label]="homePage?.slider[3]?.buttonAccessibilityText ? homePage?.slider[3]?.buttonAccessibilityText : null"
            class="btn btn-secondary learn-more-btn" [class.hideLearnMore]="hideLearnMore3">
            {{homePage?.slider[0]?.actionLabelNew}}
          </a>
        </div>
      </article>
    </div>
  </div>
  

  <!-- navigation links end here -->
  <!-- </div> -->
  <!-- benefits section start here -->
  <section class="marketplace-benefit" *ngIf="!loginFlag" style="margin-top: -80px;">
    <span class="benefit-header">
      <a href="javascript:void(0)" (click)="checkSlider(homePage?.slider[0]?.buttonLink, homePage?.slider[0]?.title)">
        <h2>{{homePage.benefitsection && homePage.benefitsection.header}}</h2>
      </a>
    </span>
    <div class="col-md-6 second-row benefit-header">
      <div class="subtitle bullet-list" [innerHTML]="homePage.benefitsection && homePage.benefitsection.desc">
      </div>
    </div>
    <span class="hide-benefit">
      <h2>{{homePage.benefitsection && homePage.benefitsection.header}}</h2>
    </span>
    <div class="container-box inner-wrap">
      <div class="row container-flex">
        <div class="col-md-6 first-row" style="margin-top: 15px;">
          <div class="small-container-flex">
            <img alt="{{homePage.benefitsection.imagealt}}" src="{{homePage.benefitsection.image}}" />
            <app-bluebox></app-bluebox>
          </div>
        </div>
        <div class="col-md-6 second-row hide-benefit">
          <div class="subtitle bullet-list" [innerHTML]="homePage.benefitsection && homePage.benefitsection.desc">
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- benefits section end here -->

  <!-- register user start here -->
  <section *ngIf="!loginFlag && homePage.loginsection  && firstNetFlag" class="signup-section-fn">
    <div class="container-box inner-wrap">
      <div class="row">
        <div class="col-md-8 firstNetTC" *ngIf="firstNetFlag">
          <h3 [innerHTML]="homePage.loginsection.login_desc2"></h3>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="!loginFlag && homePage.loginsection && !firstNetFlag" class="signup-section">
    <div class="container-box inner-wrap inner-container-box">
      <div class="row terms">
        <div class="col-md-6 termscols termscolumns1 terms-desc" *ngIf="!firstNetFlag">
          <p [innerHTML]="homePage.loginsection.desc1" class="footer-description"></p>
        </div>
        <div class="col-md-8 firstNetTC" *ngIf="firstNetFlag">
          <h3 [innerHTML]="homePage.loginsection.login_desc2"></h3>
        </div>
        <div *ngIf="!firstNetFlag" class="col-md-6 text-center termscols termscolumns2 left-align">
          <h3 class="align-left" [innerHTML]="homePage.loginsection && homePage.loginsection.login_desc2"></h3>
        </div>
      </div>
    </div>
  </section>
</div>
<!-- register user end here -->
<!-- profile error message popup -->
<!-- <app-modal *ngIf="showProfileErrorModal">
  <div class="model-cover terms">
    <div class="model-box-loginErrorModal">
      <div class="modal-header-loginErrorModal"></div>
        <div class="corner-button">
          <button class="close" aria-label="Close" (click)="closeOverviewModal()">x</button>
        </div>
        <h3>Login Error</h3>
        <div style="margin-bottom:10px;">Something went wrong! There is some issue with your login crdentials. Please try again later.</div>
        <div class="loginErrorModal">
          <p><a href="javascript:void(0)" class="btn btn-secondary" (click)="backToLogin()" aria-label="Back to Login">Back to Login</a></p>
        </div> 
    </div>
  </div>
</app-modal> -->
